/**
 * Ownership partition for {@link AppSubjectEnum} members.
 */
export enum SubjectScopeEnum {
	PLATFORM = 'platform',
	TENANT = 'tenant',
	WILDCARD = 'wildcard',
}
